<template>
  <Modal :id="'cmp-catalog-products-advanced_search'" @cancelled="onCancel">
    <template slot="header">{{$t('products_advanced_search')}}</template>

    <template slot="body">
      <div class="form-group s1" style="max-height:665px">
        <Dropdown
          class="dt-dropdown m2"
          :options="advancedSearchData.labelsTV"
          :selected="
            advancedSearchData.labelsTV.find((c) => c.value == label_id)
          "
          box
          :placeholder="$t('label')"
          v-on:selectedChange="(e) => onDropdownChange('label_id', e)"
          :listHeight="150"
        ></Dropdown>
        <TextField
          class="m1"
          :id="'artist'"
          v-bind="textFieldConfig"
          :value="artist"
          @valuechanged="onTextFieldValueChange"
          :placeholder="$t('artist')"
        />
        <TextField
          class="m1"
          :id="'title'"
          v-bind="textFieldConfig"
          :value="title"
          @valuechanged="onTextFieldValueChange"
          :placeholder="$t('title')"
        />
        <div class="ut-flex">
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.release_typesTV"
            :selected="
              advancedSearchData.release_typesTV.find(
                (c) => c.value == release_type
              )
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :placeholder="$t('release_type')"
            v-on:selectedChange="(e) => onDropdownChange('release_type', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.release_statusTV"
            :selected="
              advancedSearchData.release_statusTV.find(
                (c) => c.value == release_status
              )
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: -1px !important;
              flex: 1;
            "
            :placeholder="$t('release_status')"
            v-on:selectedChange="(e) => onDropdownChange('release_status', e)"
            :listHeight="150"
          ></Dropdown>
        </div>
        <div class="ut-flex">
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.formatsTV"
            :selected="
              advancedSearchData.formatsTV.find((c) => c.value == format_id)
            "
            box
            style="
                margin-left: 0px !important;
                margin-right: 5px !important;
                flex: 1;
              "
            :placeholder="$t('format')"
            v-on:selectedChange="(e) => onDropdownChange('format_id', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.format_groupsTV"
            :selected="
              advancedSearchData.format_groupsTV.find(
                (c) => c.value == format_group
              )
            "
            box
            style="
                margin-left: 0px !important;
                margin-right: -1px !important;
                flex: 1;
              "
            :placeholder="$t('format_group')"
            v-on:selectedChange="(e) => onDropdownChange('format_group', e)"
            :listHeight="150"
          ></Dropdown>
        </div>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.channelsTV"
          :selected="
            advancedSearchData.channelsTV.find((c) => c.value == channel)
          "
          box
          :placeholder="$t('channel')"
          v-on:selectedChange="(e) => onDropdownChange('channel', e)"
          :listHeight="150"
        ></Dropdown>
        <Dropdown
          class="dt-dropdown"
          :options="advancedSearchData.genresTV"
          :selected="
            advancedSearchData.genresTV.find((c) => c.value == genre_id)
          "
          box
          :placeholder="$t('genre')"
          v-on:selectedChange="(e) => onDropdownChange('genre_id', e)"
          :listHeight="150"
        ></Dropdown>
        <div class="ut-flex">
          <TextField
            class="m1"
            :type="'date'"
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :id="'release_date_from'"
            v-bind="textFieldConfig"
            :value="release_date_from"
            @valuechanged="onTextFieldValueChange"
            :placeholder="`${$t('release_date')} (${$t('start')})`"
          />
          <TextField
            class="m1"
            :type="'date'"
            style="
              margin-right: 0px !important;
              margin-left: 5px !important;
              flex: 1;
            "
            :id="'release_date_to'"
            v-bind="textFieldConfig"
            :value="release_date_to"
            @valuechanged="onTextFieldValueChange"
            :placeholder="`${$t('release_date')} (${$t('end')})`"
          />
        </div>
        <div class="ut-flex">
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.product_typesTV"
            :selected="
              advancedSearchData.product_typesTV.find(
                (c) => c.value == category_1
              )
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :placeholder="$dft.capHead($t('category'))"
            v-on:selectedChange="(e) => onDropdownChange('category_1', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.product_types2TV"
            :selected="
              advancedSearchData.product_types2TV.find(
                (c) => c.value == category_2
              )
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: -1px !important;
              flex: 1;
            "
            :placeholder="$t('category_2')"
            v-on:selectedChange="(e) => onDropdownChange('category_2', e)"
            :listHeight="150"
          ></Dropdown>
        </div>
        <div class="ut-flex">
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.price_listsTV"
            :selected="
              advancedSearchData.price_listsTV.find(
                (c) => c.value == price_list_id
              )
            "
            box
             style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :placeholder="$t('price_list')"
            v-on:selectedChange="(e) => onDropdownChange('price_list_id', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.price_codesTV"
            :selected="
              advancedSearchData.price_codesTV.find(
                (c) => c.value == price_code_id
              )
            "
            box
             style="
              margin-left: 0px !important;
              margin-right: -1px !important;
              flex: 1;
            "
            :placeholder="$t('price_codes')"
            v-on:selectedChange="(e) => onDropdownChange('price_code_id', e)"
            :listHeight="150"
          ></Dropdown>
        </div>
        <template v-if="price_list_id">
          <div class="ut-flex">
            <TextField
              class="m1"
              style="
                margin-left: 0px !important;
                margin-right: 5px !important;
                flex: 1;
              "
              :id="'price_from'"
              v-bind="textFieldConfig"
              :value="price_from"
              @valuechanged="onTextFieldValueChange"
              :placeholder="$t('price_from')"
            />
            <TextField
              class="m1"
              style="
                margin-right: 0px !important;
                margin-left: 5px !important;
                flex: 1;
              "
              :id="'price_to'"
              v-bind="textFieldConfig"
              :value="price_to"
              @valuechanged="onTextFieldValueChange"
              :placeholder="$t('price_to')"
            />
          </div>
          <div class="ut-flex">
            <TextField
              class="m1"
              style="
                margin-left: 0px !important;
                margin-right: 5px !important;
                flex: 1;
              "
              :id="'payback_from'"
              v-bind="textFieldConfig"
              :value="payback_from"
              @valuechanged="onTextFieldValueChange"
              :placeholder="$t('payback_from')"
            />
            <TextField
              class="m1"
              style="
                margin-right: 0px !important;
                margin-left: 5px !important;
                flex: 1;
              "
              :id="'payback_to'"
              v-bind="textFieldConfig"
              :value="payback_to"
              @valuechanged="onTextFieldValueChange"
              :placeholder="$t('payback_to')"
            />
          </div>
        </template>
        <div class="ut-flex">
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.accountsTV"
            :selected="
              advancedSearchData.accountsTV.find((c) => c.value == account_id)
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: 5px !important;
              flex: 1;
            "
            :placeholder="$t('account')"
            v-on:selectedChange="(e) => onDropdownChange('account_id', e)"
            :listHeight="150"
          ></Dropdown>
          <Dropdown
            class="dt-dropdown"
            :options="advancedSearchData.stock_locationsTV"
            :selected="
              advancedSearchData.stock_locationsTV.find(
                (c) => c.value == stock_location_id
              )
            "
            box
            style="
              margin-left: 0px !important;
              margin-right: -1px !important;
              flex: 1;
            "
            :placeholder="$t('stock_location')"
            v-on:selectedChange="(e) => onDropdownChange('stock_location_id', e)"
            :listHeight="150"
          ></Dropdown>
        </div>
        <DTCheckbox
          :id="'barcode_catalog_error'"
          :label="$t('barcode_cat_error')"
          :checked="barcode_catalog_error"
          @click="onBarcodeCatalogErrorClicked"
          :minH="'42px'"
          :class="'ml0'"
        />
        <div>
          <DTIconButton
            :classNames="'export'"
            :text="$t('export_xls_file')"
            :style="{
              minWidth: '148px',
              marginLeft: '-17px',
            }"
            icon="export"
            @click="onExportClick"
          />
        </div>
      </div>
      <template v-if="createGroupModalContainer">
        <v-dialog persistent v-model="createGroupModal" width="390">
          <QuickModal
            :title="$t('add_new_group')"
            :placeholder="$t('new_group_name')"
            @cancelled="onAddNewGroupModalCancel"
            @ok="onNewGroupCreated"
          />
        </v-dialog>
      </template>
    </template>

    <template slot="options" style="margin-top:20px">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button with-ico s6"
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onCreateGroup"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $t("create_group") }}
        </div>
      </button>
      <button class="dt-button v1 s6" @click.stop="onApplyClick">{{$t('apply')}}</button>
    </template>
  </Modal>
</template>

<script>
import { ensureStringObjectFromKeys } from "../../../../utility/fp";
import Modal from "../../../../dt-plugins/modal/modal";
import { ProductsService } from "../../services/products.service";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import { DTIconButton } from "../../../../plugins/button/button";
import { productListAdvancedSearchConfig } from "./products-list.vue";
import FileDownload from "js-file-download";
import QuickModal from "@plugins/quickmodal/quickmodal";
import {
  closeModal2Route,
  createModalMixin,
  openModal2Route,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { productGroupsLDTRoutes } from "../../router/routes";

export default {
  components: {
    ModalContainer,
    Modal,
    DTCheckbox,
    DTIconButton,
    QuickModal,
  },
  props: {
    advancedSearchData: {
      type: Object,
    },
    initSearchFilter: {
      required: true,
      type: Object,
      default: () => {},
    },
  },
  mixins: [
    createModalMixin("createGroup", [], {
      modalQueryKey: "modal2",
    }),
  ],
  watch: {
    initSearchFilter: {
      immediate: true,
      handler: function (to, from) {
        if (!to) {
          return;
        }
console.log({"!to": to});
        productListAdvancedSearchConfig.advancedSearchConfigKeys.map((key) => {
          this[key] = to[key];
        });
        productListAdvancedSearchConfig.booleanSearchKeys.map((key) => {
          this[key] = to[key];
        });
      },
    },
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },

      validationResult: {},

      label_id: "",
      artist: "",
      title: "",
      release_type: "",
      release_status: "",
      format_id: "",
      format_group: "",
      channel: "",
      genre_id: "",
      release_date_from: "",
      release_date_to: "",
      category_1: "",
      category_2: "",
      price_list_id: "",
      price_code_id:"",
      price_from: "",
      price_to: "",
      payback_from: "",
      payback_to: "",
      account_id: "",
      stock_location_id: "",
      stock_from: "",
      stock_to: "",

      barcode_catalog_error: false,
    };
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    // searchConfigStringKeys() {
    //   return [
    //     "label_id",
    //     "artist",
    //     "title",
    //     "release_type",
    //     "release_status",
    //     "format_id",
    //     "format_group",
    //     "channel",
    //     "genre_id",
    //     "release_date_from",
    //     "release_date_to",
    //     "category_1",
    //     "category_2",
    //     "price_list_id",
    //     "price_from",
    //     "price_to",
    //     "payback_from",
    //     "payback_to",
    //     "account_id",
    //     "stock_location_id",
    //     "stock_from",
    //     "stock_to",
    //   ];
    // },
    searchFilter: function () {
      console.log({
        "productListAdvancedSearchConfig.searchConfigStringKeys":
          productListAdvancedSearchConfig,
      });

      const no_filter_selected =
        productListAdvancedSearchConfig.advancedSearchConfigKeys.every(
          (e) => !this[e]
        );

      return {
        ...ensureStringObjectFromKeys(
          this,
          productListAdvancedSearchConfig.searchConfigStringKeys
        ),
        no_filter_selected,

        barcode_catalog_error: this.barcode_catalog_error ? 1 : 0,
      };
    },
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onApplyClick: function () {
      this.$emit("search", this.searchFilter);
    },
    onCreateGroup: function () {
      openModal2Route(this, "create_group");
    },

    onTextFieldValueChange: function (key, value) {
      this[key] = value;
    },
    onBarcodeCatalogErrorClicked: function (event) {
      this.barcode_catalog_error = event.target.checked;
    },
    onExportClick: function () {
      ProductsService.downloadAdvancedSearchXLSFile(this.searchFilter).then(
        (res) => {
          console.log('res.data',res.data)
          FileDownload(res.data, "catalog_report.xlsx");
          this.onCancel();
        }
      );
    },
    onAddNewGroupModalCancel: function () {
      closeModal2Route(this, "create_group");
    },
    onNewGroupCreated: async function (payload) {
      const newProductGroupRes =
        await ProductsService.createNewGroupAdvancedSearch({
          ...this.searchFilter,
          product_group_name1: payload,
        });
      const { product_group_id } = newProductGroupRes.data.pg;

      this.$router.push({
        name: productGroupsLDTRoutes.names.tab,
        params: {
          product_group_id,
          tab: "overview",
        },
      });
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-catalog-products-advanced_search {
}
</style>
